import React, { Component } from 'react'
import Chart from 'chart.js/auto';
import classes from "./Graph.module.css";
import 'chartjs-adapter-moment';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
import GraphZoomControls from './GraphZoomControls.js';
Chart.register(zoomPlugin);
Chart.register(annotationPlugin);

class GraphTwoCurves extends Component {
    constructor(props){
        super(props);
        this.myChart = "";
    }

    generateAnnotationsList(annotations, alertPoints1, alertPoints2, alertPointsReminder, min) {
        if (alertPoints1 !== undefined) {
            alertPoints1.forEach((e, i) => {
                let new_point = {
                    type: 'point',
                    backgroundColor: 'transparent',
                    borderColor: 'red',
                    borderWidth: 1,
                    pointStyle: 'triangle',
                    radius: 8,
                    xValue: e.x,
                    yValue: e.y,
                    yScaleID: 'y'
                }
                let new_label = {
                    type: 'label',
                    color: 'red',
                    position: {
                        x: 'center',
                        y: 'end'
                    },
                    content: (ctx) => 'Alert',
                    font: {
                        size: 10
                    },
                    xValue: e.x,
                    yValue: e.y,
                    yScaleID: 'y'
                }
                annotations["alertPoints1_" + i] = new_point
                annotations["alertLabel1_" + i] = new_label
            })
        }
        if (alertPoints2 !== undefined) {
            alertPoints2.forEach((e, i) => {
                let new_point = {
                    type: 'point',
                    backgroundColor: 'transparent',
                    borderColor: 'red',
                    borderWidth: 1,
                    pointStyle: 'triangle',
                    radius: 8,
                    xValue: e.x,
                    yValue: e.y,
                    yScaleID: 'y1'
                }
                let new_label = {
                    type: 'label',
                    color: 'red',
                    position: {
                        x: 'center',
                        y: 'end'
                    },
                    content: (ctx) => 'Alert',
                    font: {
                        size: 10
                    },
                    xValue: e.x,
                    yValue: e.y,
                    yScaleID: 'y1'
                }
                annotations["alertPoints2_" + i] = new_point
                annotations["alertLabel2_" + i] = new_label
            })
        }
        if (this.props.alertPointsReminder !== undefined && this.props.alertPointsReminder.length > 0) {
            alertPointsReminder.forEach((e, i) => {
                let eventTime = new Date(e.x)
                let new_point = {
                    type: 'point',
                    backgroundColor: 'transparent',
                    borderColor: 'red',
                    borderWidth: 1,
                    pointStyle: 'crossRot',
                    radius: 8,
                    yAdjust: -6,
                    xValue: eventTime.toISOString(),
                    yValue: min,
                    yScaleID: 'y'
                }
                let new_label = {
                    type: 'label',
                    color: 'red',
                    position: {
                        x: 'center',
                        y: 'end'
                    },
                    content: (ctx) => '?',
                    font: {
                        size: 10
                    },
                    yAdjust: -3,
                    xValue: eventTime.toISOString(),
                    yValue: min,
                    yScaleID: 'y'
                }
                annotations["alertPoints_reminder_" + i] = new_point
                annotations["alertLabel_reminder_" + i] = new_label
            })
        }
        return (annotations)
    }

    updateAnnotationsList(annotations, alertPoints1, alertPoints2, alertPointsReminder, min) {
        alertPoints1.forEach((e, i) => {
            annotations["alertPoints1_" + i].xValue = e.x
            annotations["alertPoints1_" + i].yValue = e.y
            annotations["alertLabel1_" + i].xValue = e.x
            annotations["alertLabel1_" + i].yValue = e.y
        })
        alertPoints2.forEach((e, i) => {
            annotations["alertPoints2_" + i].xValue = e.x
            annotations["alertPoints2_" + i].yValue = e.y
            annotations["alertLabel2_" + i].xValue = e.x
            annotations["alertLabel2_" + i].yValue = e.y
        })
        alertPointsReminder.forEach((e, i) => {
            let eventTime = new Date(e.x)
            eventTime.setHours(0)
            eventTime.setMinutes(0)
            eventTime.setSeconds(0)
            annotations["alertPoints_reminder_" + i].xValue = eventTime.toISOString()
            annotations["alertPoints_reminder_" + i].yValue = min
            annotations["alertLabel_reminder_" + i].xValue = eventTime.toISOString()
            annotations["alertLabel_reminder_" + i].yValue = min
        })
        return (annotations)
    }

    componentDidMount() {
        var ctx = document.getElementById(this.props.id_graph);
        if (ctx === null) {
            ctx = this.props.new_window.document.getElementById(this.props.id_graph);
        }

        var local_max_x = 0;
        var local_min_x = 0;
        var curve1Drawing = [];
        var curve1ThresholdDrawing = [];
        var curve2Drawing = [];
        var curve2ThresholdDrawing = [];
        var currentTimeDrawing  = [];
        var annotations = {}

        if(this.props.curve1 !== undefined){
            local_max_x             = this.props.max_x;
            local_min_x             = this.props.min_x;
            curve1Drawing           =  this.props.curve1;
            curve1ThresholdDrawing  =  this.props.threshold1;
            if((this.props.alertPoints1 !== undefined && this.props.alertPoints1.length > 0) || (this.props.alertPoints2 !== undefined && this.props.alertPoints2.length > 0) || (this.props.alertPointsReminder !== undefined && this.props.alertPointsReminder.length > 0)){
                annotations = this.generateAnnotationsList(annotations, this.props.alertPoints1, this.props.alertPoints2, this.props.alertPointsReminder, this.props.min1)
            }                
            curve2Drawing           =  this.props.curve2;
            curve2ThresholdDrawing  =  this.props.threshold2;
            currentTimeDrawing      =  this.props.currentTime;
        }

        this.myChart = new Chart(ctx, {
            type: 'line',
            data: {
                datasets: [
                    {
                        label: this.props.curve1_name,
                        data: curve1Drawing,
                        showLine: false,
                        fill: false,
                        pointBackgroundColor: this.props.curve1_color,
                        pointBorderWidth: 0,
                        pointRadius: this.props.pointRadius || 4,
                        yAxisID: 'y'
                    },
                    {
                        label: this.props.threshold1_name,
                        data: curve1ThresholdDrawing,
                        borderColor: this.props.threshold1_color,
                        borderWidth: 1,
                        pointBackgroundColor: this.props.threshold1_color,
                        showLine: true,
                        pointBorderWidth: 0, 
                        pointRadius: 0,
                        yAxisID: 'y'
                    },
                    {
                        label: this.props.curve2_name,
                        data: curve2Drawing,
                        showLine: false,
                        fill: false,
                        pointBackgroundColor: this.props.curve2_color,
                        pointBorderWidth: 0,
                        pointRadius: this.props.pointRadius || 4,
                        yAxisID: 'y1'
                    },
                    {
                        label: this.props.threshold2_name,
                        data: curve2ThresholdDrawing,
                        borderColor: this.props.threshold2_color,
                        borderWidth: 1,
                        pointBackgroundColor: this.props.threshold2_color,
                        showLine: true,
                        pointBorderWidth: 0,
                        pointRadius: 0,
                        yAxisID: 'y1'
                    },
                    {
                        label: 'Maintenant',
                        data: currentTimeDrawing,
                        borderColor: "#E7DFD8",
                        pointBackgroundColor: "#E7DFD8",
                        showLine: true,
                        pointBorderWidth: 0,
                        pointRadius: 0,
                        yAxisID: 'y1'
                    }
                ],
            },
            options: {
                parsing: false,
                normalized: true,
                responsive: true,
                animation: false,
                hitRadius: 0,
                plugins: {
                    title: {
                        color: 'black',
                        font : {weight: 'bold'},
                        display: this.props.title !== undefined,
                        text: this.props.title
                    },
                    zoom: {
                        pan: {
                            enabled: true,
                            mode: 'x',
                            threshold: 5,
                            modifierKey: 'shift',
                        },
                        limits: {
                          x: {min: 'original', max: 'original', minRange: 3600000},
                          y: {min: 'original', max: 'original'},
                        },
                        zoom: {
                          wheel: {
                            enabled: true,
                          },
                          pinch: {
                            enabled: true
                          },
                          drag: {
                            enabled: true,
                            backgroundColor: 'rgba(40, 150, 229, 0.15)',
                            borderColor: 'rgba(40, 150, 229, 0.8)',
                            borderWidth: 1,
                            threshold: 5,
                          },
                          mode: 'x',
                        }
                      },
                     annotation: {
                        annotations
                    },
                    tooltip: {
                        backgroundColor:'rgba(0,0,0,0.8)',  // black with transparency
                    },
                    legend: {
                      display: false
                    }
                },
      
                scales: {
                    x: {
                        id:'xAxis1',
                        type: 'time',
                        min: local_min_x,
                        max: local_max_x,
                        distribution: 'series',
                        time: {
                            displayFormats: {
                                hour: 'H',
                            },
                            unit: 'hour',
                            tooltipFormat: 'MMM D - HH:mm'
                        },
                        ticks: {
                          minRotation: 0,
                          maxRotation: 0,
                          major: {
                            enabled: true
                          },
                          font: function(context) {
                            if (context.tick && context.tick.major) {
                              return {
                                weight: 'bold',
                              };
                            }
                          }
                        }
                    },
                    y: {
                        min: this.props.min1,
                        max: this.props.max1,
                        title: {
                            display: this.props.y_axis_title1 !== undefined,
                            padding: 0,
                            text: this.props.y_axis_title1,
                            color: this.props.threshold1_color
                        },
                        position: 'left',
                        ticks: {
                          color: this.props.threshold1_color,
                        },
                        grid: {
                          drawOnChartArea: false,
                        }
                    },
                    y1: {
                        min: this.props.min2,
                        max: this.props.max2,
                        title: {
                            display: this.props.y_axis_title2 !== undefined,
                            padding: 0,
                            text: this.props.y_axis_title2,
                            color: this.props.threshold2_color
                        },
                        position: 'right',
                        major: {
                            enabled: false
                        },
                        grid: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                        },
                        ticks: {
                          color: this.props.threshold2_color, 
                        },
                    }
                }
            }
        });
    }

    updateData() {
        if((this.myChart !== undefined)&&(this.myChart.data !== undefined)){
                // Skip refresh while zoomed/panned so the periodic update does
                // not snap the view back to the full range. Resumes on reset.
                if(this.myChart.isZoomedOrPanned && this.myChart.isZoomedOrPanned()){ return; }
                this.myChart.options.scales.x.max  = this.props.max_x;
                this.myChart.options.scales.x.min  = this.props.min_x;
                this.myChart.data.datasets[0].data = this.props.curve1;
                this.myChart.data.datasets[1].data = this.props.threshold1;
                this.myChart.data.datasets[2].data = this.props.curve2;
                this.myChart.data.datasets[3].data = this.props.threshold2;
                this.myChart.data.datasets[4].data = this.props.currentTime;
            if(this.props.alertPoints1 !== undefined || this.props.alertPoints2 !== undefined || this.props.alertPointsReminder !== undefined){
                this.myChart.options.plugins.annotation.annotations = this.updateAnnotationsList(this.myChart.options.plugins.annotation.annotations, this.props.alertPoints1, this.props.alertPoints2, this.props.alertPointsReminder, this.props.min1)
            }                                            
                this.myChart.update();
            }
    }

    render() {
        return (
            <div className={classes.graphContainer} style={{display: "flex", flexDirection: "column", height: "100%", width: "100%"}}>
                <div style={{flex: "1 1 auto", minHeight: 0, width: "100%", display: "flex", justifyContent:'center', alignItems:'center'}}>
                    <canvas
                        style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
                        id={this.props.id_graph}
                        ref={this.chartRef}
                    />
                </div>
                <GraphZoomControls
                    getChart={() => this.myChart}
                    onEnlarge={this.props.onEnlarge}
                />
                {
                    this.updateData()
                }
            </div>
        )
    }
}
export default (GraphTwoCurves)